import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M9.75 10.5c2.071 0 3.75 1.679 3.75 3.75v1.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.5C12 13.007 10.993 12 9.75 12h-6c-1.243 0-2.25 1.007-2.25 2.25v1.5c0 .414-.336.75-.75.75S0 16.164 0 15.75v-1.5c0-2.071 1.679-3.75 3.75-3.75zm4.524.66c.103-.401.512-.642.913-.539C16.842 11.05 18 12.541 18 14.25v1.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.5c0-1.025-.695-1.92-1.687-2.176-.402-.104-.643-.513-.54-.914zM6.75 1.5c2.071 0 3.75 1.679 3.75 3.75C10.5 7.321 8.821 9 6.75 9 4.679 9 3 7.321 3 5.25 3 3.179 4.679 1.5 6.75 1.5zm4.523.661c.103-.4.512-.643.913-.54 1.66.425 2.82 1.92 2.82 3.633s-1.16 3.208-2.82 3.633c-.401.102-.81-.14-.913-.541-.102-.401.14-.81.541-.913.996-.254 1.692-1.152 1.692-2.18 0-1.027-.696-1.924-1.692-2.179-.401-.103-.643-.511-.54-.913zM6.75 3C5.507 3 4.5 4.007 4.5 5.25S5.507 7.5 6.75 7.5 9 6.493 9 5.25 7.993 3 6.75 3z"
	})
});
export default SvgUsers;
